import React, { useContext, useEffect, useReducer, useState } from "react";
import styles from "./Step.module.css";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import Vacancy from "../../../assets/componentAssets/Vacancy.svg";
import { InputAdornment, TextField } from "@mui/material";
import info from "../../../assets/componentAssets/info.svg";

import CustomInput from "../../../Components/CustomInput/CustomInput";
import { reducer } from "../consumptionReducer";
import { form4State } from "../InitialState/form4State";
import { convertCommaToDot, convertDotToComma, formStep4 } from "../../../Utility/utils";
import NavButton from "./NavButton";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import { PatchApi, getApi } from "../../../Utility/network";
import { incrementByOneYear, monthYear } from "../utility/utils";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
import CustomCheckBox from "../../../Components/CustomCheckBox/CustomCheckBox";
import { consumCertEngText } from "../../../Utility/engLangObject";
import { consumCertGerText } from "../../../Utility/gerLangObject";
import { germanMonths } from "../../Need/utility/utils";

function Step4() {
  const {
    state: contextState,
    setState,
    HandleErrorPop,
  } = useContext(AppContext);
  const { stepLanguage, language } = contextState;
  const [state, dispatch] = useReducer(reducer, form4State);
  const [year, setYear] = useState();
  const [response, setResponse] = useState(false);
  const [review, setReview] = useState({ review: [] });
  const [showData, setShowData] = useState([]);
  const [vacancyData, setVacancyData] = useState([]);
  const [pop, setPop] = useState(false);
  const [infoText, setInfoText] = useState([]);
  const [errors, setErrors] = useState([]);
  const validateHeatingInfoArray = (heatingInfoArray) => {
    // Initialize errors array
    const errors = vacancyData.map(() => ({
      from_date: "",
      to_date: "",
      percentage: "",
      climate_factor: "",
    }));

    vacancyData.forEach((vac, vaccIndex) => {
      const heatingErrors = errors[vaccIndex];
      if (language === "de") {
        const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
        let newVac = vac.percentage.toString();
        newVac = convertCommaToDot(newVac.toString()); // Convert comma to dot for further validation

        if (
          typeof newVac !== "string" || // Ensure input is a string
          !regex.test(vac.percentage) || // Validate format: digits, optional comma
          parseFloat(newVac) < 0 || // Check range: >= 0
          parseFloat(newVac) > 100 // Check range: <= 100
        ) {
          heatingErrors.percentage = `${stepLanguage.per_pos}`; // Set error message
        }
      } else {
        const newVac = vac.percentage.toString(); // Convert comma to dot for further validation
        if (
          typeof newVac !== "string" || // Ensure input is a string
          !/^\d+(\.\d+)?$/.test(newVac) || // Regex to validate numbers and decimals
          parseFloat(newVac) < 0 || // Check range: >= 0
          parseFloat(newVac) > 100 // Check range: <= 100
        ) {
          heatingErrors.percentage = `${stepLanguage.per_pos}`; // Set error message
        }
      }
      // if (language === "de") {
      //   const regex = /[-eE+.]/g;
      //   let check = regex.test(vac.percentage);
      //   let newVac = convertCommaToDot(vac.percentage.toString());
      //   if (
      //     typeof newVac !== "string" || // Ensure it's a string to validate properly
      //     !/^\d+(\.\d+)?$/.test(newVac) || // Regex to validate numbers and decimals
      //     parseFloat(newVac) < 0 || // Check range: >= 0
      //     parseFloat(newVac) > 100 // Check range: <= 100
      //   ) {
      //     heatingErrors.percentage = `${stepLanguage.per_pos}`;
      //   }
      // } else {
      //   if (
      //     typeof vac.percentage !== "string" || // Ensure it's a string to validate properly
      //     !/^\d+(\.\d+)?$/.test(vac.percentage) || // Regex to validate numbers and decimals
      //     parseFloat(vac.percentage) < 0 || // Check range: >= 0
      //     parseFloat(vac.percentage) > 100 // Check range: <= 100
      //   ) {
      //     heatingErrors.percentage = `${stepLanguage.per_pos}`;
      //   }
      // }
    });
    return errors;
  };
  const handleSubmit = async (num, type) => {
    try {
      if (type === "next") {
        const errors = validateHeatingInfoArray(vacancyData);
        const checkError = isAllFieldsEmpty(errors);
        setErrors(errors);
        if (!checkError) return;
        let newVacancyData = vacancyData.map((item, index) => {
          return {
            ...item,
            percentage: convertCommaToDot(item.percentage.toString()),
          };
        });
        try {
          const postData = await PatchApi(
            `/energy_consumption/form/${contextState.form_id}/`,
            { vacancy: newVacancyData, language: language === "de" ? 2 : 1 }
          );
          if (postData.status === 200 || postData.status === 201) {
            setState((prev) => ({
              ...prev,
              filledPage: prev.filledPage >= 5 ? prev.filledPage : 5,
              page: 5,
              otherData: { ...prev.otherData, vacancy: newVacancyData },
            }));
          } else {
            throw Error("api failed");
          }
        } catch (error) {
          alert(error);
        }
      } else if (type === "prev") {
        setState((prev) => ({ ...prev, page: prev.page - 1 }));
      } else if (type === "save") {
        await getApi(
          `/energy_consumption/form/${contextState.form_id}/generate_link`
        );
        setResponse(true);
        // navigate("/login");
      }
    } catch (error) {
      HandleErrorPop(true);
    }
  };
  const style = { width: "100%" };
  useEffect(() => {
    // if (contextState.otherData.construction_year) {
    //   const data = vacancy.map((item, index) => {
    //     let addNum =
    //       Number(contextState.otherData.construction_year) + index + 1;
    //     return {
    //       ...item,
    //       from_date: addNum,
    //       to_date: addNum + 1,
    //     };
    //   });
    //   setShowData(data);
    // }
  }, [contextState.otherData.construction_year]);
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    // if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
    const datass = [...vacancyData];
    datass[index].percentage = e.target.value;
    setVacancyData(datass);
    // }
    // const data = [...showData];
    // data[index].percentage = e.target.value;
    // console.log(data, "percent");
    // setShowData(data);
  };

  useEffect(() => {
    if (contextState.otherData && contextState.otherData.yearArray) {
      const newArr = contextState?.otherData?.yearArray?.map((item, index) => {
        return { ...item, show: 1 };
      });
      setShowData(newArr);
    }
  }, [contextState.otherData.yearArray]);

  useEffect(() => {
    setVacancyData((prev) => {
      const datas = [];
      const { vacancy } = contextState.otherData;
      if (vacancy && vacancy.length > 0) {
        let newVacancy = vacancy.map((item, index) => {
          return {
            ...item,
            percentage:
              language == "de"
                ? convertDotToComma(item.percentage)
                : item.percentage,
          };
        });
        return newVacancy;
      } else {
        showData.forEach((item, index) => {
          if (index !== 0) return;
          item.consumption_info.forEach((item1, index1) => {
            const dd = {
              ...vacancy1,
              from_date: item1.date,
              to_date: incrementByOneYear(1, item1.date),
            };
            datas.push(dd);
          });
        });
        return datas;
      }
    });
  }, [showData, contextState.otherData]);

  useEffect(() => {
    const { vacancy } = contextState.otherData;
    if (vacancy) {
      setVacancyData(vacancy);
    }
  }, [contextState.otherData]);

  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const popData = {
    vacancy: [
      {
        heading: stepLanguage.vacancy_h,
        para1: stepLanguage.vacancy_d1,
        para2: stepLanguage.vacancy_d12,
        para3: stepLanguage.vacancy_d3,
      },
    ],
  };
  const handleCheckboxChange = (name, checkedIds) => {
    setReview({ review: checkedIds });
  };
  return (
    <div>
      <div className={styles.con}>
        <StepsHeader
          image={Vacancy}
          heading={contextState.headerLanguage.vacancy_info}
          secPara={stepLanguage.Please_provide_proper_information}
        />
        <div className={styles.fieldDetails}>
          <div>
            {/* <CustomCheckBox
              data={contextState.language === "en" ? data : dataGerman}
              name="review"
              onCheckChange={handleCheckboxChange}
              selectedValues={review.review}
            /> */}
          </div>
          {/* {review.review.length > 0 && ( */}
          <div>
            <p className={styles.text}>{stepLanguage.vacancy_info_paragraph}</p>
            <div className={styles.fieldCom}>
              {vacancyData.map((item, index) => {
                const date = new Date(item.from_date);
                // Get the month (0-based index, so add 1 to get 1-based month)
                const month = date.getMonth();
                // Get the year
                const year = date.getFullYear();
                const percentageErrorMessage = errors[index]?.percentage;
                return (
                  <div className={styles.vacancyInput}>
                    <p className={styles.fieldName}>
                      {/* {monthYear(item1.date)} */}
                      {stepLanguage.vacancy_from_this}{" "}
                      {language === "de"
                        ? germanMonths[month]
                        : monthsdd[month]}{" "}
                      {year} {stepLanguage.to}{" "}
                      {language === "de"
                        ? germanMonths[month - 1]
                        : monthsdd[month - 1]}{" "}
                      {year + 1}
                      <img
                        src={info}
                        style={{ cursor: "pointer" }}
                        onClick={() => handlePopUp(popData?.vacancy)}
                      />
                    </p>
                    <TextField
                      size="small"
                      style={style}
                      onChange={(e) => handleChange(e, index)}
                      type="text"
                      onWheel={(e) => e.target.blur()}
                      // value={item.percentage}
                      value={item.percentage}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                      error={percentageErrorMessage}
                      helperText={percentageErrorMessage}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          {/* )} */}
        </div>
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        response={response}
        setResponse={setResponse}
      />

      {pop && (
        <PopUpInfo
          handleClose={() => setPop(false)}
          open={pop}
          data={infoText}
        />
      )}
    </div>
  );
}

export default Step4;

const vacancy = [
  {
    from_date: "2020-03-10",
    to_date: "2021-02-10",
    percentage: null,
    climate_factor: 1.14,
  },
  {
    from_date: "2021-03-10",
    to_date: "2022-02-10",
    percentage: null,
    climate_factor: 1.14,
  },
  {
    from_date: "2022-03-10",
    to_date: "2023-02-10",
    percentage: null,
    climate_factor: 1.18,
  },
];

const vacancy1 = {
  from_date: "2020-03-10",
  to_date: "2021-02-10",
  percentage: 0,
  climate_factor: 1.14,
};

const monthsdd = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const isAllFieldsEmpty = (errors) => {
  // Iterate through each object in the errors array
  return errors.every((errorObj) => {
    // Check if all properties are empty strings (ignore arrays)
    return Object.keys(errorObj).every((key) => {
      const value = errorObj[key];
      // Check if the value is an empty string (ignore arrays)
      return typeof value === "string" && value === "";
    });
  });
};

const data = [
  {
    title: consumCertEngText.prolonged,
    id: 1,
  },
];

const dataGerman = [
  {
    title: consumCertGerText.prolonged,
    id: 1,
  },
];
